module.exports = __webpack_public_path__ + "img/8.b5ecb7b1.jpg";